import React from 'react';

export default function StatusDot({ value, label }) {
  let color = 'bg-gray-400';
  let text = 'Unknown';
  if (value === 1 || value === '1') {
    color = 'bg-green-500';
    text = 'Yes';
  } else if (value === 0 || value === '0') {
    color = 'bg-red-500';
    text = 'No';
  }
  return (
    <span
      className={`inline-block w-3 h-3 rounded-full ${color}`}
      aria-label={`${label}: ${text}`}
      title={`${label}: ${text}`}
    />
  );
}